var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleLang,attrs:{"id":"app"}},[(_vm.showHeaderFooter)?_c('myHeader',{on:{"getpath":_vm.getpath}}):_vm._e(),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1),(_vm.showHeaderFooter)?_c('myFooter',{attrs:{"pathname":_vm.pathname}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }